import { createRoutine } from 'redux-saga-routines';
import { LIST_TIMEZONES, GET_TIMEZONE } from './types';

export const listTimezones = createRoutine(LIST_TIMEZONES);
export const getTimezone = createRoutine(GET_TIMEZONE);
